export default __webpack_public_path__ + "static/media/linkedinIconWhite.aecb25bf.svg";